<template>
    <b-card
        header-tag="header"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <div slot="header">
            <b-row>
                <b-col>
                    <div class="mb-2 mt-1">{{ title }}</div>
                </b-col>
                <b-col>
                    <b-form-group horizontal label="Type" class="mb-0 inline">
                        <b-form-select 
                            v-model="form.type" 
                            :options="types" 
                            size="sm" 
                            @input="typeChange" 
                            style="background-color: white;"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <form @submit.prevent="saveAddress()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="12">
                    <b-form-group label="Address Line 1" label-for="address1">
                        <b-form-input
                            id="address1"
                            name="address1"
                            type="text"
                            required
                            v-model="form.address1"
                            >
                        </b-form-input>
                        <input-help :form="form" field="address1" text="Enter your street number and name here."></input-help>
                    </b-form-group>
                    <b-form-group label="Address Line 2" label-for="address2">
                        <b-form-input
                            id="address2"
                            name="address2"
                            type="text"
                            v-model="form.address2"
                            >
                        </b-form-input>
                        <input-help :form="form" field="address2" text="Enter an apartment number or additional address info here."></input-help>
                    </b-form-group>
                    <b-form-group label="City" label-for="city">
                        <b-form-input
                            id="city"
                            name="city"
                            type="text"
                            v-model="form.city"
                            >
                        </b-form-input>
                        <input-help :form="form" field="city" text="Enter the city here."></input-help>
                    </b-form-group>
                    <b-form-group label="County" label-for="county">
                        <b-form-input
                            id="county"
                            name="county"
                            type="text"
                            v-model="form.county">
                        </b-form-input>
                        <input-help :form="form" field="county" text="Enter the county here."></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="state">
                        <b-form-input
                            id="state"
                            name="state"
                            type="text"
                            v-model="form.state"
                            >
                        </b-form-input>
                        <input-help :form="form" field="state" text="Enter the state or province here."></input-help>
                    </b-form-group>
                    <b-form-group label="Zip Code" label-for="zip">
                        <b-form-input
                            id="zip"
                            name="zip"
                            type="text"
                            v-model="form.zip"
                            >
                        </b-form-input>
                        <input-help :form="form" field="zip" text="Enter the zip code or postal code here."></input-help>
                    </b-form-group>
                    <b-form-group label="Country" label-for="country">
                        <b-form-select name="country" id="country" :options="countries.getOptions()" v-model="form.country">
                        </b-form-select>
                        <input-help :form="form" field="country" text="Select the country from the drop down."></input-help>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="12">
                    <b-button variant="success" type="submit">Save Address</b-button>
                </b-col>
            </b-row>
        </form>
    </b-card>
</template>

<script>
    export default {
        props: {
            'title': '',
            'user': null,
            'address': null,
            'action': null
        },

        data() {
            return {
                form: new Form(),
                countries: new Countries(),
            }
        },

        mounted() {
            this.setForm(this.address);
        },

        computed: {
            types() {
                if (this.user && this.user.role_type == 'client') {
                    return [
                        { text: 'Primary Residence', value: 'primary' },
                        { text: 'Alternative Residence', value: 'alternate' },
                        { text: 'Hospital or Facility', value: 'hospital' },
                        { text: 'Other', value: 'other' },
                    ];
                }

                return [
                    { text: 'Home', value: 'home' },
                    { text: 'Work', value: 'work' },
                    { text: 'Mobile', value: 'mobile' },
                    { text: 'Other 1', value: 'other_1' },
                    { text: 'Other 2', value: 'other_2' },
                    { text: 'Other 3', value: 'other_3' }
                ];
            },
        },

        methods: {
            saveAddress() {
                let action = (this.action) ? this.action : '/profile/address/' + this.form.type;
                this.form.post(action)
                    .then( ({data}) => {
                        this.setForm(data.data);
                        window.scroll(0, 0);
                    });
            },

            setForm(data) {
                this.form = new Form({
                    id: data.id,
                    address1: data.address1,
                    address2: data.address2,
                    city: data.city,
                    state: data.state,
                    zip: data.zip,
                    country: (data.country) ? data.country : 'US',
                    county: data.county,
                    type: data.type,
                });
            },

            typeChange(value) {
                this.form.type = value;
                this.buttonVisible = true;
            },
        },

        watch: {
            address(newVal) {
                this.setForm(newVal);
            },
        }
    }
</script>

<style>
.inline .form-row { align-items: center }
</style>